/**
**  项目管理---项目详情界面
 */
<template>
  <div id="ProjectDetail" class="jc-page">
    <div class="jc-panel jc-page-head">
      <span class="header-title">
        <el-page-header style="float:left;" @back="goBack" :content="currentProject.checkup_project_name">
        </el-page-header>
        <span v-if="projectSummaryInfo.checkup_project_status_info"
          style="padding:0 10px;float:left;font-size:14px;font-weight:normal;height:24px;line-height:24px;margin-left:10px;"
          :style="{
            color: projectSummaryInfo.checkup_project_status_info.checkup_project_status_name == '待开始' ? '#EF8C2B' : '#55AF70',
            backgroundColor: projectSummaryInfo.checkup_project_status_info.checkup_project_status_name == '待开始' ? '#FDF3E9' : '#EEF7F0'
          }">
          {{ projectSummaryInfo.checkup_project_status_info.checkup_project_status_name }}
        </span>
      </span>
      <div class="header-operation">
        <el-button class="border-btn" @click="goToProjectHistory">项目历史</el-button>
        <el-button class="border-btn" @click="openProjectDocument">项目文档</el-button>
        <el-button class="border-btn" @click="openProjectMember">项目成员</el-button>
        <el-button @click="saveAsWord()">生成报告</el-button>
        <el-button @click="openModifyProject">项目编辑</el-button>
        <el-button @click="deleteProject">项目删除</el-button>
      </div>
    </div>
    <div class="jc-table-container jc-scroll-panel" style="padding:0px;background:#f3f3f3;">
      <div id="timeLineDiv">
        <el-timeline>
          <el-timeline-item v-for="(activity, index) in checkup_project_time_list" :key="index"
            :timestamp="activity.create_date">
            {{ activity.checkup_project_name }}
          </el-timeline-item>
        </el-timeline>
      </div>
      <!-- 检查列表 -->
      <div id="CheckTable">
        <h3>检查列表</h3>
        <el-table :data="checkup_item_list" style="margin:0 10px;width:calc(100% - 20px);">
          <el-table-column prop="checkup_subject_name" label="检查表名称" min-width="180">
          </el-table-column>
          <el-table-column label="操作" width="200" fixed="right">
            <template slot-scope="scope">
              <el-button @click="checkHandleEdit(scope.row)" type="text" size="small">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog class="jc-dialog" :visible.sync="showProjectMemberDialog" title="项目成员"
      :before-close="cancelProjectMemberDialog">
      <el-table :data="projectMemberData" style="width: 100%">
        <el-table-column prop="organization_user_real_name" label="成员">
        </el-table-column>
        <el-table-column prop="organization_user_mobile" label="联系方式">
        </el-table-column>
        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-button @click.native.prevent="deleteProjectMember(scope.row)" type="text" size="small">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button @click="addProjectMember" style="margin-top:20px;" icon="el-icon-plus">添加成员</el-button>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelProjectMemberDialog">取消</el-button>
        <el-button type="primary" @click="okProjectMemberDialog">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showModifyProjectDialog" title="项目编辑"
      :before-close="cancelModifyProjectDialog">
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showProjectDocumentDialog" title="项目文档"
      :before-close="cancelProjectDocumentDialog">
      <el-button @click="openManageCategoryDialog"
        style="float:right;margin-right:20px;background:#EBF4FF;color:#3894FF;border:none;">管理分类</el-button>
      <div>
        <el-table :data="projectDocumentData" style="width: 100%">
          <el-table-column prop="checkup_project_file_url_info.file_name" label="文档名称">
          </el-table-column>
          <el-table-column prop="checkup_project_file_category_info.checkup_project_file_category_name" label="文档分类">
          </el-table-column>
          <el-table-column prop="create_date" label="时间">
          </el-table-column>
          <el-table-column width="100" label="操作">
            <template slot-scope="scope">
              <a style="color:#409EFF;font-size:12px;text-decoration:none;" target="view_window"
                :href="scope.row.checkup_project_file_url_info.url">查看</a>
              <el-button @click.native.prevent="modifyProjectDocument(scope.row)" type="text" size="small">
                编辑
              </el-button>
              <el-button @click.native.prevent="deleteProjectDocument(scope.row)" type="text" size="small">
                删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="openDocuemntUploadDialog">文档上传</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showCategoryDialog" title="管理分类" :before-close="cancelCategoryManager">
      <div class="manage-category-dialog">
        <div class="manage-category-dialog-title" style="text-align:left;margin-bottom:10px;">
          <span>文档分类</span>
          <span style="float:right;">
            <el-button size="mini" type="primary" @click="addNewCategory">新增分类</el-button>
            <el-button @click="deleteFileCategory" size="mini" type="danger">删除分类</el-button>
          </span>
        </div>
        <div style="margin:5px 0;">
          <span class="custom-tree-node" style="color:#101010;font-size:14px;">
            <span>文档分类名称</span>
            <span style="display:inline-block;width:66px;text-align:left;">操作</span>
          </span>
        </div>
        <el-tree ref="fileCategoryTreeRef" :check-strictly="true" :data="checkup_project_file_category_list_tree"
          show-checkbox node-key="checkup_project_file_category_id" default-expand-all>
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ data.checkup_project_file_category_name }}</span>
            <span>
              <el-button @click="modifyFileCateogry(data)" size="mini" type="text">编辑</el-button>
              <el-button @click="deleteFileCateogry(data)" size="mini" type="text">删除</el-button>
            </span>
          </span>
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCategoryManager">取消</el-button>
        <el-button type="primary" @click="okCategoryManager">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showDocumentUploadDialog" title="文档上传"
      :before-close="cancelUploadProjectDocument">
      <el-form>
        <el-form-item label="文档分类">
          <el-cascader :show-all-levels="false" clearable style="width:100%;"
            v-model="uploadFileForm.checkup_project_file_category_id" :options="checkup_project_file_category_list_tree"
            placeholder="请选择上级分类"
            :props="{ checkStrictly: true, label: 'checkup_project_file_category_name', value: 'checkup_project_file_category_id' }"></el-cascader>
          <el-button @click="openManageCategoryDialog"
            style="background:#EBF4FF;color:#3894FF;border:none;">新增分类</el-button>
        </el-form-item>
        <el-form-item label="文档上传">
          <br>
          <el-upload :data="uploadParam" ref="upload" :action="UploadFileUrl()" :on-success="uploadSuccess">
            <div>
              <el-button size="small" type="primary">点击上传</el-button>
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelUploadProjectDocument">取消</el-button>
        <el-button type="primary" @click="okUploadProjectDocument">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showModifyFileInfoDialog" title="修改文档分类"
      :before-close="cancelModifyProjectDocument">
      <el-form>
        <el-form-item label="文档分类">
          <el-cascader :show-all-levels="false" clearable style="width:100%;" v-model="checkup_project_file_category_id"
            :options="checkup_project_file_category_list_tree" placeholder="请选择上级分类"
            :props="{ checkStrictly: true, label: 'checkup_project_file_category_name', value: 'checkup_project_file_category_id' }"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelModifyProjectDocument">取消</el-button>
        <el-button type="primary" @click="okModifyProjectDocument">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showNewCategoryDialog" title="新增分类" :before-close="cancelNewFileCategory">
      <el-form :model="newFileCategoryForm">
        <el-form-item label="上级分类">
          <el-cascader :show-all-levels="false" clearable style="width:100%;"
            v-model="newFileCategoryForm.checkup_project_file_category_parent_id"
            :options="checkup_project_file_category_list_tree" placeholder="请选择上级分类"
            :props="{ checkStrictly: true, label: 'checkup_project_file_category_name', value: 'checkup_project_file_category_id' }"></el-cascader>
        </el-form-item>
        <el-form-item label="分类名称">
          <el-input v-model="newFileCategoryForm.checkup_project_file_category_name" placeholder="请输入分类名称"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNewFileCategory">取消</el-button>
        <el-button type="primary" @click="addNewFileCategory">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog class="jc-dialog" :visible.sync="showNewProjectMemberDialog" title="新增成员"
      :before-close="cancelNewProjectMember">
      <div>
        <el-table ref="multipleTable" :data="personData" style="width: 100%">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column label="姓名" prop="organization_user_real_name"></el-table-column>
          <el-table-column label="性别" prop="organization_user_sex">
            <template slot-scope="scope">
              {{ scope.row.organization_user_sex == "1" ? '男' : (scope.row.organization_user_sex == "0" ? '保密' : '女') }}
            </template>
          </el-table-column>
          <el-table-column label="手机号" prop="organization_user_mobile"></el-table-column>
          <el-table-column label="职务/职称" prop="organization_user_position_name"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="addNewMemberRow(scope.row)" type="text" size="small">添加</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background style="text-align:right" @size-change="handleNewMemberSizeChange"
          @current-change="handleNewMemberCurrentChange" :current-page.sync="newMemberCurrentPage"
          :page-size="newMemberCount" layout="total, prev, pager, next" :total="newMemberTotal">
        </el-pagination>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelNewProjectMember">取消</el-button>
        <el-button type="primary" @click="okNewProjectMember">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" class="jc-dialog" :visible.sync="showAddDialog"
      :title="isGoingProject ? '项目详情' : '项目编辑'" :before-close="cancelAddDialog">
      <el-form style="display:block;" label-position="top" :model="addFormModel" :rules="addFormRules" ref="addForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="项目名称">
              <el-input :disabled="isGoingProject" v-model="addFormModel.checkup_project_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目类型">
              <el-select disabled clearable v-model="addFormModel.checkup_project_type_id">
                <el-option v-for="item in modifyProjectProjectTypeList" :key="item.checkup_project_type_id"
                  :label="item.checkup_project_type_name" :value="item.checkup_project_type_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="适用机构类型">
              <el-select disabled clearable v-model="addFormModel.checkup_project_organization_type_id"
                @change="OrganizationTypeChange">
                <el-option v-for="item in modifyProjectOrganizationTypeList" :key="item.organization_type_id"
                  :label="item.organization_type_name" :value="item.organization_type_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="评估类型">
              <el-select disabled clearable v-model="addFormModel.evaluation_type_id">
                <el-option v-for="item in modifyProjectEvaluationTypeList" :key="item.evaluation_type_id"
                  :label="item.evaluation_type_name" :value="item.evaluation_type_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="行动周期">
              <el-select disabled clearable v-model="addFormModel.action_period_id" @change="ActionPeriodChange">
                <el-option v-for="item in modifyProjectActionPeriodList" :key="item.action_period_id"
                  :label="item.action_period_name" :value="item.action_period_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="开始时间">
              <el-date-picker disabled clearable value-format="yyyy" v-model="addFormModel.start_date"
                :type="modifyProjectActionPeriod" placeholder="请选择开始时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="结束时间">
              <el-date-picker disabled clearable value-format="yyyy" v-model="addFormModel.end_date"
                :type="modifyProjectActionPeriod" placeholder="请选择结束时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="负责人">
              <el-select :disabled="isGoingProject" clearable v-model="addFormModel.checkup_project_charge_user_id">
                <el-option v-for="item in modifyProjectUserList" :key="item.organization_user_id"
                  :label="item.organization_user_real_name" :value="item.organization_user_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="项目评级">
              <el-select  :disabled="isGoingProject"  clearable v-model="addFormModel.level">
                <el-option v-for="item in levelList" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="jc-dialog-section-head">本机检查表</div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="项目">
              <el-select disabled clearable v-model="addFormModel.base_checkup_project_id"
                @change="TemplateCheckupProjectChange">
                <el-option v-for="item in modifyProjectTemplateCheckupProjectList" :key="item.base_checkup_project_id"
                  :label="item.base_checkup_project_name" :value="item.base_checkup_project_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否打分">
              <el-select disabled clearable v-model="addFormModel.is_score">
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="modifyProjectSelfCheckupSubjectList.length > 0">
          <el-col :span="24">
            <el-form-item>
              <el-checkbox-group :disabled="isGoingProject" v-model="addFormModel.self_checkup_subject_id_list">
                <el-checkbox v-for="item in modifyProjectSelfCheckupSubjectList" :label="item.base_checkup_subject_id"
                  :key="item.base_checkup_subject_id">
                  {{ item.base_checkup_subject_name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="jc-dialog-section-head">接受机构及检查表</div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="接受机构">
              <el-select :disabled="isGoingProject" multiple clearable
                v-model="addFormModel.distribute_organization_id_list">
                <el-option v-for="item in modifyProjectNextLevelOrganizationList" :key="item.organization_id"
                  :label="item.organization_name" :value="item.organization_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="modifyProjectDistributeCheckupSubjectList.length > 0">
          <el-col :span="24">
            <el-form-item>
              <el-checkbox-group :disabled="isGoingProject" v-model="addFormModel.distribute_checkup_subject_id_list">
                <el-checkbox v-for="item in modifyProjectDistributeCheckupSubjectList"
                  :label="item.base_checkup_subject_id" :key="item.base_checkup_subject_id">
                  {{ item.base_checkup_subject_name }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAddDialog">取 消</el-button>
        <el-button type="primary" @click="okAddDialog">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import htmlDocx from 'html-docx-js/dist/html-docx';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
import saveAs from 'file-saver';
import { eventBus } from "../../../../eventbus/index";
import {
  getCheckupProjectFileCategoryList,
  deleteCheckupProjectUserInfo,
  saveCheckupProjectUserInfo,
  getCheckupProjectUserList,
  getCheckupProjectTimeList,
  getCheckupProjectDetail,
  getCheckupItemListInSubject,
  saveCheckupProjectFileCategoryInfo,
  deleteCheckupProjectFileCategoryInfo,
  deleteCheckupProjectInfo,
  getSelfCheckupSubjectList,
  // getDistributeCheckupSubjectList,
  generateWordDecumentsForProjectReports,
  editCheckupProjectInfo,
  saveCheckupProjectFileInfo,
  getCheckupProjectFileList,
  deleteCheckupProjectFileInfo,
  getCheckupSubjectListInProject,
} from '@/apis/projects'
import { getRegionTreeList, getCheckupProjectList } from '@/apis/projectManage'
import {
  getNextLevelOrganizationList,
  getUserList,
  getActionPeriodList,
  getOrganizationTypeList,
  getEvaluationTypeList,
  getCheckupProjectTypeList
} from '@/apis/info'
import { getToken, getUserId, getIdentityType } from '@/utils/auth'
export default {
  name: "ProjectDetail",
  data() {
    return {
      content: null,
      uploadParam: {
        device_type: 20,
        user_id: getUserId(),
        token: getToken(),
        identity_type: getIdentityType(),
        jsonText: JSON.stringify({ "file_type_key": "checkup_project_file" })
      },
      addFormRules: {

      },
      addFormModel: {
        "checkup_project_name": "",
        "checkup_project_organization_type_id": "",
        "checkup_project_type_id": "",
        "is_score": "",
        "level":"Z",
        "action_period_id": "",
        "evaluation_type_id": "",
        "start_date": "",
        "end_date": "",
        "checkup_project_charge_user_id": "",
        "base_checkup_project_id": "",
        "self_checkup_subject_id_list": [],
        "distribute_organization_id_list": [],
        "distribute_checkup_subject_id_list": []
      },
      levelList: [{
        value: 'A',
        label: 'A'
      }, {
        value: 'B',
        label: 'B'
      }, {
        value: 'C',
        label: 'C'
      }, {
        value: 'D',
        label: 'D'
      }, {
        value: 'E',
        label: 'E'
      }, {
        value: 'Z',
        label: '未评级'
      }],
      newMemberCurrentPage: 1,
      newMemberCount: 10,
      newMemberTotal: 0,

      currentProject: {},
      checkup_project_id: '',
      checkup_project_time_list: [],
      checkup_item_list: [],

      showProjectDocumentDialog: false,
      showProjectMemberDialog: false,
      showModifyProjectDialog: false,
      showCategoryDialog: false,
      showDocumentUploadDialog: false,
      showNewCategoryDialog: false,
      showNewProjectMemberDialog: false,
      showAddDialog: false,

      projectMemberData: [],
      projectDocumentData: [],
      categoryData: [
        {
          checkup_project_file_category_id: 1,
          checkup_project_file_category_name: 'a',
          children: [{
            checkup_project_file_category_id: 11,
            checkup_project_file_category_name: 'aa'
          }]
        }
      ],
      checkup_project_file_category_list: [],
      checkup_project_file_category_list_tree: [],
      newFileCategoryForm: {
        checkup_project_file_category_id: '',
        checkup_project_file_category_parent_id: '',
        checkup_project_file_category_name: ''
      },
      personData: [],

      modifyProjectRegionTreeList: [],
      modifyProjectOrganizationTypeList: [],
      modifyProjectEvaluationTypeList: [],
      modifyProjectProjectTypeList: [],
      modifyProjectActionPeriodList: [],
      modifyProjectActionPeriod: 'year',
      modifyProjectUserList: [],
      modifyProjectTemplateCheckupProjectList: [],
      modifyProjectNextLevelOrganizationList: [],
      modifyProjectSelfCheckupSubjectList: [],
      modifyProjectDistributeCheckupSubjectList: [],
      modifyProjectprojectList: [],

      uploadFileUrl: '',
      isUploading: false,
      uploadFileForm: {
        "checkup_project_file_id": "0",
        "checkup_project_id": "",
        "checkup_project_file_category_id": "",
        "checkup_project_file_url": ""
      },
      projectList: [],
      projectSummaryInfo: {},
      isGoingProject: false,
      modifyFileInfo: {},
      showModifyFileInfoDialog: false,
      checkup_project_file_category_id: '0',
      uploadUrl: process.env.BASE_API
    };
  },
  mounted() {
    // console.log(this.$route)
    this.checkup_project_id = this.$route.params.id
    this.loadBasicData()
    this.loadData()
    this.loadProjectInfoData()
    this.openCreateReport()

  },
  methods: {
    UploadFileUrl: function () {
      return this.uploadUrl + "/Base/Tools/editFile";
    },
    cancelModifyProjectDocument() {
      this.showModifyFileInfoDialog = false
    },
    okModifyProjectDocument() {
      let that = this
      // console.log(this.modifyFileInfo)
      saveCheckupProjectFileInfo({
        "checkup_project_file_id": this.modifyFileInfo.checkup_project_file_id,
        "checkup_project_id": this.checkup_project_id,
        "checkup_project_file_category_id": this.checkup_project_file_category_id[this.checkup_project_file_category_id.length - 1],
        "checkup_project_file_url": this.modifyFileInfo.checkup_project_file_url_info.path
      }).then(res => {
        this.cancelModifyProjectDocument()
        this.loadProjectDocumentData()
      })
    },
    uploadSuccess(res, file, filelist) {
      // console.log(res)
      if (res.status == 0) {
        this.$message.error(res.msg)
        this.$refs.upload.clearFiles()
      } else {
        this.uploadFileUrl = res.data.file_info.path
      }
    },
    TemplateCheckupProjectChange(base_checkup_project_id) {
      getSelfCheckupSubjectList({
        checkup_project_id: this.checkup_project_id,
        base_checkup_project_id: base_checkup_project_id
      }).then(res => {
        console.log(res)
        this.modifyProjectSelfCheckupSubjectList = res.data.data.base_self_checkup_subject_list
      })
      getDistributeCheckupSubjectList({
        checkup_project_id: this.checkup_project_id,
        base_checkup_project_id: base_checkup_project_id
      }).then(res => {
        // console.log(res)
        this.modifyProjectDistributeCheckupSubjectList = res.data.data.base_distribute_checkup_subject_list
      })
    },
    ActionPeriodChange(type) {
      let item = this.modifyProjectActionPeriodList.find(x => x.action_period_id == type)
      if (item) {
        switch (item.action_period_name) {
          case '年': this.modifyProjectActionPeriod = 'year'; break
          case '月': this.modifyProjectActionPeriod = 'month'; break
          case '日': this.modifyProjectActionPeriod = 'date'; break
        }
      }
    },
    OrganizationTypeChange(id) {
      getTemplateCheckupProjectList({
        organization_type_id: id
      }).then(res => {
        this.modifyProjectTemplateCheckupProjectList = res.data.data.base_checkup_project_list
      })
    },
    cancelAddDialog() {
      this.showAddDialog = false
      this.addFormModel = {
        "checkup_project_name": "",
        "checkup_project_organization_type_id": "",
        "checkup_project_type_id": "",
        "is_score": "",
        "level":"Z",
        "action_period_id": "",
        "evaluation_type_id": "",
        "start_date": "",
        "end_date": "",
        "checkup_project_charge_user_id": "",
        "base_checkup_project_id": "",
        "self_checkup_subject_id_list": [],
        "distribute_organization_id_list": [],
        "distribute_checkup_subject_id_list": []
      }
    },
    okAddDialog() {
      if (this.isGoingProject) {
        this.cancelAddDialog()
        return;
      }
      editCheckupProjectInfo({
        "checkup_project_id": this.checkup_project_id,
        "checkup_project_name": this.addFormModel.checkup_project_name,
        "checkup_project_charge_user_id": this.addFormModel.checkup_project_charge_user_id,
        "self_checkup_subject_id_list": this.addFormModel.self_checkup_subject_id_list,
        "distribute_organization_id_list": this.addFormModel.distribute_organization_id_list,
        "distribute_checkup_subject_id_list": this.addFormModel.distribute_checkup_subject_id_list,
        "level":this.addFormModel.level
      }).then(res => {
        console.log(this.addFormModel.checkup_project_charge_user_id);
        if (res.data.status === '1') {
          this.$message.success("修改成功")
        }
        this.cancelAddDialog()
      })
    },
    loadProjectInfoData() {
      getRegionTreeList().then(res => {
        this.modifyProjectRegionTreeList = res.data.data.region_tree_list
      })
      getOrganizationTypeList().then(res => {
        this.modifyProjectOrganizationTypeList = res.data.data.organization_type_list
      })
      getEvaluationTypeList().then(res => {
        this.modifyProjectEvaluationTypeList = res.data.data.evaluation_type_list
      })
      getCheckupProjectTypeList().then(res => {
        this.modifyProjectProjectTypeList = res.data.data.checkup_project_type_list
      })
      getActionPeriodList().then(res => {
        this.modifyProjectActionPeriodList = res.data.data.action_period_list
      })
      getUserList({
        organization_user_real_name: '',
        pagination: {
          page: 1,
          count: 1000
        }
      }).then(res => {
        this.modifyProjectUserList = res.data.data.organization_user_list
        console.log(this.modifyProjectUserList)
      })
      getNextLevelOrganizationList().then(res => {
        this.modifyProjectNextLevelOrganizationList = res.data.data.organization_next_level_list
      })
      getCheckupProjectDetail({
        checkup_project_id: this.checkup_project_id
      }).then(res => {
        this.currentProject = res.data.data.checkup_project_info
        let self_checkup_subject_id_list = []
        let distribute_organization_id_list = []
        let distribute_checkup_subject_id_list = []
        this.currentProject.self_checkup_subject_list.forEach(x => {
          self_checkup_subject_id_list.push(x.base_checkup_subject_id)
        })
        this.currentProject.distribute_organization_list.forEach(x => {
          distribute_organization_id_list.push(x.organization_id)
        })
        this.currentProject.distribute_checkup_subject_list.forEach(x => {
          distribute_checkup_subject_id_list.push(x.base_checkup_subject_id)
        })
        this.addFormModel = {
          "checkup_project_name": this.currentProject.checkup_project_name,
          "checkup_project_organization_type_id": this.currentProject.checkup_project_organization_type_info.checkup_project_organization_type_id,
          "checkup_project_type_id": this.currentProject.checkup_project_type_info.checkup_project_type_id,
          "is_score": this.currentProject.is_score,
          "level":this.currentProject.level,
          "action_period_id": this.currentProject.action_period_info.action_period_id,
          "evaluation_type_id": this.currentProject.evaluation_type_info.evaluation_type_id,
          "start_date": this.currentProject.start_date,
          "end_date": this.currentProject.end_date,
          "checkup_project_charge_user_id": this.modifyProjectUserList[0].organization_user_id,
          "base_checkup_project_id": this.currentProject.base_checkup_project_id,
          "self_checkup_subject_id_list": self_checkup_subject_id_list,
          "distribute_organization_id_list": distribute_organization_id_list,
          "distribute_checkup_subject_id_list": distribute_checkup_subject_id_list
        }
        console.log(this.addFormModel)
        getSelfCheckupSubjectList({
          checkup_project_id: this.checkup_project_id,
          base_checkup_project_id: res.data.data.checkup_project_info.base_checkup_project_id
        }).then(res => {
          this.modifyProjectSelfCheckupSubjectList = res.data.data.base_self_checkup_subject_list
        })
        getDistributeCheckupSubjectList({
          checkup_project_id: this.checkup_project_id,
          base_checkup_project_id: res.data.data.checkup_project_info.base_checkup_project_id
        }).then(res => {
          this.modifyProjectDistributeCheckupSubjectList = res.data.data.base_distribute_checkup_subject_list
        })
      })

    },
    cancelNewProjectMember() {
      this.showNewProjectMemberDialog = false
    },
    okNewProjectMember() {
      this.showNewProjectMemberDialog = false
      this.loadProjectMemberData()
    },
    handleNewMemberSizeChange(val) {

    },
    handleNewMemberCurrentChange(val) {
      this.loadPersonData()
    },
    addNewMemberRow(row) {
      saveCheckupProjectUserInfo({
        "checkup_project_id": this.checkup_project_id,
        "organization_user_id": row.organization_user_id
      }).then(res => {
        if (res.data.status == "1") {
          this.$message.success("添加成功")
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    loadPersonData() {
      getUserList({
        "organization_user_real_name": '',
        "pagination": {
          "page": this.newMemberCurrentPage,
          "count": this.newMemberCount
        }
      }).then(res => {
        this.personData = res.data.data.organization_user_list
      })
    },
    loadData() {
      getCheckupProjectList({
        "checkup_project_name": "",
        "checkup_project_status_id": "",
        "start_date": "",
        "end_date": "",
        "pagination": {
          "page": 1,
          "count": 100
        }
      }).then(res => {
        this.projectList = res.data.data.checkup_project_list
        this.projectSummaryInfo = this.projectList.find(x => x.checkup_project_id == this.checkup_project_id)
        this.isGoingProject = this.projectSummaryInfo.checkup_project_status_info.checkup_project_status_name == '进行中' ? true : false
      })
      getCheckupProjectDetail({
        checkup_project_id: this.checkup_project_id
      }).then(res => {
        this.currentProject = res.data.data.checkup_project_info
      })
      getCheckupProjectTimeList({
        checkup_project_id: this.checkup_project_id
      }).then(res => {
        this.checkup_project_time_list = [...res.data.data.checkup_project_time_list]
      })
      getCheckupSubjectListInProject({
        checkup_project_id: this.checkup_project_id,
      }).then(res => {
        this.checkup_item_list = res.data.data.checkup_subject_list
      })
    },
    loadBasicData() {

    },
    goBack() {
      this.$router.back()
    },
    goToProjectHistory() {
      this.$router.push('/projectManag/ProjectHistory/' + this.checkup_project_id)
    },
    openProjectDocument() {
      this.showProjectDocumentDialog = true
      this.loadProjectDocumentData()
    },
    loadProjectDocumentData() {
      getCheckupProjectFileList({
        "checkup_project_id": this.checkup_project_id
      }).then(res => {
        this.projectDocumentData = res.data.data.checkup_project_file_list
      })
    },
    openCreateReport() {
      // this.$router.push('/projectManag/ProjectReport/' + this.checkup_project_id);
      this.exportWordTpl(this.checkup_project_id);
    },
    exportWordTpl(id) {
      let temp;
      generateWordDecumentsForProjectReports({
        "project_id": this.checkup_project_id
      }).then(res => {
        temp = res.data.data;
        console.log(temp);
        switch (temp.data.type) {
          case "1":
            this.templateA(temp)
            break;
          case "2":
            this.templateA(temp)
            break;
          case "3":
            this.templateC(temp)
            break;
          case "4":
            this.templateD(temp)
            break;
        }
      })
    },
    templateA(temp) {
      let strVar = "";
      //首页
      for (let i = 0; i < 5; i++) {
        strVar += "<br>";
      }
      if (temp.data.type == "1") {
        strVar += "<div style=\"font-size: 30px;text-align:center;\">XXXX(政府考核类)评估报告<\/div>";
      } else {
        strVar += "<div style=\"font-size: 30px;text-align:center;\">XXXX(安全城市示范创建类)评估报告<\/div>";
      }
      for (let i = 0; i < 30; i++) {
        strVar += "<br>";
      }
      strVar += "<div style=\"font-size: 14px;text-align:center;\">XXXX办公室<\/div>";
      strVar += "<div style=\"font-size: 19px;text-align:center;\">" + temp.data.year + "年" + temp.data.month + "月<\/div>";
      strVar += "<span lang=EN-US style='font-size:10.5pt;font-family:等线'><br clear=all style='page-break-before:always'><\/span>";

      //专家表
      strVar += "<h3>表1 评估专家组名单<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>姓名<\/td>";
      strVar += "            <td>性别<\/td>";
      strVar += "            <td>手机号<\/td>";
      strVar += "            <td>专业<\/td>";
      strVar += "            <td>职务\/职称<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("expert")) {
        for (var i = 0; i < temp.expert.length; i++) {
          strVar += "<tr> <td>" + i + "<\/td> <td>" + temp.expert[i].expert_real_name + "<\/td> <td>" + temp.expert[i].expert_sex + "<\/td> <td>" + temp.expert[i].expert_mobile + "<\/td> <td>" + temp.expert[i].expert_position_name + "<\/td> <td>" + temp.expert[i].speciality + "<\/td> <\/tr>";
        }
      }
      strVar += "    <\/table>";
      strVar += "<\/div>";

      //抽查表
      strVar += "<h3>表2 抽查单位（检查对象）列表<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>对象名称<\/td>";
      strVar += "            <td>对象类型<\/td>";
      strVar += "            <td>对象地址<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("inspect")) {
        for (var i = 0; i < temp.inspect.length; i++) {
          strVar += "<tr> <td>" + i + "<\/td> <td>" + temp.inspect[i].checkup_object_name + "<\/td> <td>" + temp.inspect[i].checkup_object_type + "<\/td> <td>" + temp.inspect[i].checkup_object_address + "<\/td> <\/tr>";
        }
      }
      strVar += "    <\/table>";
      strVar += "<\/div>";

      //成绩表
      strVar += "<h3>表3 评估成绩表<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"400\" border=\"1\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td rowspan=\"2\">名称<\/td>";
      strVar += "            <td rowspan=\"2\">总分<\/td>";
      var count = 0;
      if (temp.hasOwnProperty("project")) {
        for (const key in temp.project[temp.project.length - 1]) {
          count += 1;
        }
      }
      var num = count - 1;
      strVar += "            <td colspan=\"" + num + "\">专题考核<\/td>";
      strVar += "        <\/tr>";
      strVar += "        <tr>";
      var index = 0;
      const stack = [];
      if (temp.hasOwnProperty("project")) {
        for (const key in temp.project[temp.project.length - 1]) {
          if (!temp.project[temp.project.length - 1][key].hasOwnProperty("project_name")) {
            strVar += "            <td>" + key + "<\/td>";
            stack.push(key);
          }
        }
      }
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("project")) {
        temp.project.forEach(element => {
          strVar += "        <tr>";
          var tempData = [];
          for (let iterator in element) {
            tempData.push(iterator)
          }
          let indey = 1;
          strVar += "            <td>" + element[tempData[index]].project_name + "<\/td>";
          strVar += "            <td>" + element[tempData[index]].project_score + "<\/td>";
          var tempResult = new Array();
          for (var i = 0; i < 4; i++) {
            tempResult[i] = "            <td> <\/td>";
          }
          for (let index = 0; index < num; index++) {
            if (stack.indexOf(tempData[indey]) != -1) {
              tempResult[stack.indexOf(tempData[indey])] = "            <td>" + element[tempData[indey]].checkup_subject_final_base_score_total + "<\/td>";
              indey++;
            } else {
            }
          }
          for (let index = 0; index < num; index++) {
            strVar += tempResult[index];
          }
          strVar += "        <\/tr>";
        });
      }
      strVar += "<\/table>";
      strVar += "<\/div>";


      //项目问题和隐患清单
      var index = 1;
      strVar += "<h3>表4 项目问题和隐患清单<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      strVar += "        <tr style=\"font-size:11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>专题<\/td>";
      strVar += "            <td>类别<\/td>";
      strVar += "            <td>项目<\/td>";
      strVar += "            <td>评估内容<\/td>";
      strVar += "            <td>标准分<\/td>";
      strVar += "            <td>评分标准<\/td>";
      strVar += "            <td>评估依据<\/td>";
      strVar += "            <td>问题描述<\/td>";
      strVar += "            <td>整改意见<\/td>";
      strVar += "            <td>扣分<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("hidden")) {
        temp.hidden.forEach(element => {
          var num = 0;
          for (const key in element) {
            num = num + 1;
          }
          var deepIndex = 0;
          for (const key in element) {
            strVar += "        <tr style=\"font-size:11\">";
            strVar += "            <td>" + index + "<\/td>";
            if (deepIndex == 0) {
              strVar += "            <td rowspan=\"" + num + "\">" + element[key].object_name + "<\/td>";
            }
            strVar += "            <td>" + element[key].checkup_category + "<\/td>";
            strVar += "            <td>" + element[key].subject_name + "<\/td>";
            strVar += "            <td>" + element[key].checkup_item_evaluation_content + "<\/td>";
            strVar += "            <td>" + element[key].checkup_item_basic_score + "<\/td>";
            strVar += "            <td>" + element[key].checkup_item_score_point + "<\/td>";
            strVar += "            <td>" + element[key].checkup_item_inspection_basis + "<\/td>";
            strVar += "            <td>";
            if (element[key].checkup_evaluation_problem_description) {
              element[key].checkup_evaluation_problem_description.forEach(element => {
                strVar += element + "<br>";
              }
              )
            } else {
              strVar += "null";
            }
            strVar += "<\/td>";
            strVar += "            <td>";
            if (element[key].checkup_evaluation_improve_suggest) {
              element[key].checkup_evaluation_improve_suggest.forEach(element => {
                strVar += element + "<br>";
              }
              )
            } else {
              strVar += "null";
            }
            strVar += "<\/td>";
            strVar += "            <td>" + element[key].checkup_item_evaluation_actual_score + "<\/td>";
            strVar += "        <\/tr>";
            deepIndex = deepIndex + 1;
            index = index + 1;
          }
        });
      }
      strVar += "<\/table>";
      strVar += "<\/div>";
      this.outputWord(strVar);
    },

    templateC(temp) {
      let strVar = "";
      //首页
      strVar += "<div style=\"font-size: 18px;text-align:right;\">xxxx【xxx】xxx<\/div>";
      strVar += "<br>";
      strVar += "<div style=\"font-size: 48px;text-align:center;\">企业安全生产标准化<\/div>";
      strVar += "<br>";
      strVar += "<div style=\"font-size: 35px;text-align:center;\">评审报告<\/div>";
      for (let i = 0; i < 26; i++) {
        strVar += "<br>";
      }
      strVar += "<div style=\"font-size: 14px;text-align:center;\">申请企业:_________________________<\/div>";
      strVar += "<div style=\"font-size: 14px;text-align:center;\">评审单位:_________________________<\/div>";
      strVar += "<div style=\"font-size: 14px;text-align:center;\">评审行业:__________专业:__________<\/div>";
      strVar += "<div style=\"font-size: 14px;text-align:center;\">申请企业:__________级别:__________<\/div>";
      strVar += "<div style=\"font-size: 14px;text-align:center;\">评审日期:" + temp.data.start_time + "至" + temp.data.end_time + "<\/div>";
      for (let i = 0; i < 3; i++) {
        strVar += "<br>";
      }
      strVar += "<div style=\"font-size: 14px;text-align:center;\">国家安全生产监督管理总局制<\/div>";
      strVar += "<span lang=EN-US style='font-size:10.5pt;font-family:等线'><br clear=all style='page-break-before:always'><\/span>";

      //专家表
      strVar += "<h3>表1 评估专家组名单<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"2\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>姓名<\/td>";
      strVar += "            <td>性别<\/td>";
      strVar += "            <td>手机号<\/td>";
      strVar += "            <td>专业<\/td>";
      strVar += "            <td>职务\/职称<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("expert")) {
        for (var i = 0; i < temp.expert.length; i++) {
          strVar += "<tr> <td>" + i + "<\/td> <td>" + temp.expert[i].expert_real_name + "<\/td> <td>" + temp.expert[i].expert_sex + "<\/td> <td>" + temp.expert[i].expert_mobile + "<\/td> <td>" + temp.expert[i].expert_position_name + "<\/td> <td>" + temp.expert[i].speciality + "<\/td> <\/tr>";
        }
      }
      strVar += "    <\/table>";
      strVar += "<\/div>";

      //检查结果清单
      strVar += "<h3>附表-检查结果清单<\/h3>";
      if (temp.hasOwnProperty("hidden")) {
        for (const key in temp.hidden) {
          strVar += "<h4>" + key + "检查表<\/h4>";
          strVar += "<div style=\"text-align: center;\">";
          strVar += "<table align=\"center\" width=\"600\" border=\"2\">";
          strVar += "        <tr style=\"font-size=11\">";
          strVar += "            <td>序号<\/td>";
          strVar += "            <td>考评内容<\/td>";
          strVar += "            <td>考评说明<\/td>";
          strVar += "            <td>应得分<\/td>";
          strVar += "            <td>实得分<\/td>";
          strVar += "            <td>备注<\/td>";
          strVar += "        <\/tr>";
          var index = 1;
          for (const val in temp.hidden[key]) {
            strVar += "        <tr style=\"font-size=11\">";
            strVar += "            <td>" + index + "<\/td>";
            strVar += "            <td>" + temp.hidden[key][val].checkup_item_name + "<\/td>";
            strVar += "            <td>" + temp.hidden[key][val].checkup_item_score_point + "<\/td>";
            strVar += "            <td>" + temp.hidden[key][val].checkup_item_basic_score + "<\/td>";
            strVar += "            <td>" + temp.hidden[key][val].checkup_item_evaluation_actual_score + "<\/td>";
            strVar += "            <td>" + temp.hidden[key][val].checkup_item_evaluation_inspection_result + "<\/td>";
            strVar += "        <\/tr>";
            index ++;
          }
          strVar += "    <\/table>";
          strVar += "<\/div>";
        }
      }

      strVar += "<span lang=EN-US style='font-size:10.5pt;font-family:等线'><br clear=all style='page-break-before:always'><\/span>";
      this.outputWord(strVar);
    },

    templateD(temp) {
      let dataset = ["a. 资质证照",
        "b. 安全生产管理机构及人员",
        "c. 安全生产责任制",
        "d. 安全生产管理制度",
        "e. 安全操作规程",
        "f. 教育培训",
        "g. 安全生产管理档案",
        "h. 安全生产投入",
        "i. 应急管理",
        "j. 特种设备基础管理",
        "k. 职业卫生基础管理",
        "l. 相关方基础管理",
        "m. 其他基础管理",
        "a. 特种设备现场管理",
        "b. 生产设备设施及工艺",
        "c. 场所环境",
        "d. 从业人员操作行为",
        "e. 消防安全",
        "f. 用电安全",
        "g. 职业卫生现场安全",
        "h. 有限空间现场安全",
        "i. 辅助动力系统",
        "j. 相关方现场管理",
        "k. 其他现场管理"
      ];
      let strVar = "";
      //首页
      strVar += "<br>";
      strVar += "<div style=\"font-size: 30px;text-align:center;\">xxxx（安全检查类）报告<\/div>";
      for (let i = 0; i < 36; i++) {
        strVar += "<br>";
      }
      strVar += "<div style=\"font-size: 14px;text-align:center;\">xxxx技术服务有限公司<\/div>";
      strVar += "<br>";
      strVar += "<div style=\"font-size: 19px;text-align:center;\">" + temp.data.time + "<\/div>";
      strVar += "<span lang=EN-US style='font-size:10.5pt;font-family:等线'><br clear=all style='page-break-before:always'><\/span>";

      //专家表
      strVar += "<h3>表1 评估专家组名单<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>姓名<\/td>";
      strVar += "            <td>性别<\/td>";
      strVar += "            <td>手机号<\/td>";
      strVar += "            <td>专业<\/td>";
      strVar += "            <td>职务\/职称<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("expert")) {
        for (var i = 0; i < temp.expert.length; i++) {
          strVar += "<tr> <td>" + i + "<\/td> <td>" + temp.expert[i].expert_real_name + "<\/td> <td>" + temp.expert[i].expert_sex + "<\/td> <td>" + temp.expert[i].expert_mobile + "<\/td> <td>" + temp.expert[i].expert_position_name + "<\/td> <td>" + temp.expert[i].speciality + "<\/td> <\/tr>";
        }
      }
      strVar += "    <\/table>";
      strVar += "<\/div>";

      //抽查表
      strVar += "<h3>表2 抽查单位（检查对象）列表<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td>序号<\/td>";
      strVar += "            <td>对象名称<\/td>";
      strVar += "            <td>对象类型<\/td>";
      strVar += "            <td>对象地址<\/td>";
      strVar += "        <\/tr>";
      if (temp.hasOwnProperty("inspect")) {
        for (var i = 0; i < temp.inspect.length; i++) {
          strVar += "<tr> <td>" + i + "<\/td> <td>" + temp.inspect[i].checkup_object_name + "<\/td> <td>" + temp.inspect[i].checkup_object_type + "<\/td> <td>" + temp.inspect[i].checkup_object_address + "<\/td> <\/tr>";
        }
      }
      strVar += "    <\/table>";
      strVar += "<\/div>";

      //问题统计
      strVar += "<h3>表3 问题统计<\/h3>";
      strVar += "<div style=\"text-align: center;\">";
      strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
      var rowArray = [];
      var ObjNum = 0;
      if (temp.hasOwnProperty("hidden")) {
        for (const key in temp.hidden) {
          var tempRow = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, ""];
          tempRow[25] = key;
          for (const index in temp.hidden[key].evaluation) {
            tempRow[index] = temp.hidden[key].evaluation[index];
          }
          tempRow[24] = temp.hidden[key].evaluation_count;
          rowArray.push(tempRow);
          ObjNum = ObjNum + 1;
        }
      }
      var newArray = rowArray[0].map(function (col, i) {
        return rowArray.map(function (row) {
          return row[i];
        })
      });
      strVar += "        <tr style=\"font-size=11\">";
      strVar += "            <td><\/td>";
      strVar += "            <td><\/td>";
      strVar += "            <td><\/td>";
      strVar += "            <td colspan=\"" + ObjNum + "\">检查对象<\/td>";
      strVar += "        <\/tr>";
      strVar += "        <tr>";
      strVar += "            <td><\/td>";
      strVar += "            <td><\/td>";
      strVar += "            <td><\/td>";
      for (let index = 0; index < ObjNum; index++) {
        const element = newArray[25][index];
        strVar += "            <td>" + element + "<\/td>";
      }
      strVar += "        <\/tr>";
      strVar += "        <tr>";
      strVar += "            <td rowspan=\"24\">问题分类及数量<\/td>";
      strVar += "            <td rowspan=\"13\">基础管理<\/td>";
      strVar += "            <td>a. 资质证照<\/td>";
      for (let index = 0; index < ObjNum; index++) {
        const element = newArray[0][index];
        strVar += "            <td>" + element + "<\/td>";
      }
      strVar += "        <\/tr>";
      var i = 1;
      for (i; i < 13; i++) {
        strVar += "        <tr>";
        strVar += "            <td>" + dataset[i] + "<\/td>";
        for (let index = 0; index < ObjNum; index++) {
          const element = newArray[i][index];
          strVar += "            <td>" + element + "<\/td>";
        }
        strVar += "        <\/tr>";
      }
      strVar += "        <tr>";
      strVar += "            <td rowspan=\"11\">现场管理<\/td>";
      strVar += "            <td>a. 特种设备现场管理<\/td>";
      for (let index = 0; index < ObjNum; index++) {
        const element = newArray[13][index];
        strVar += "            <td>" + element + "<\/td>";
      }
      strVar += "        <\/tr>";
      i += 1;
      for (i; i < 24; i++) {
        strVar += "        <tr>";
        strVar += "            <td>" + dataset[i] + "<\/td>";
        for (let index = 0; index < ObjNum; index++) {
          const element = newArray[i][index];
          strVar += "            <td>" + element + "<\/td>";
        }
        strVar += "        <\/tr>";
      }
      strVar += "            <td colspan=\"3\">问题数量合计<\/td>";
      for (let index = 0; index < ObjNum; index++) {
        const element = newArray[24][index];
        strVar += "            <td>" + element + "<\/td>";
      }
      strVar += "<\/table>";
      strVar += "<\/div>";


      //项目问题和隐患清单
      strVar += "<h3>附表-问题和隐患清单<\/h3>";
      if (temp.hasOwnProperty("danger")) {
        for (const key in temp.danger) {
          strVar += "<h4>" + key + "检查表<\/h4>";
          strVar += "<div style=\"text-align: center;\">";
          strVar += "<table align=\"center\" width=\"600\" border=\"1\">";
          strVar += "        <tr style=\"font-size:11\">";
          strVar += "            <td rowspan=\"2\">专业<\/td>";
          strVar += "            <td rowspan=\"2\">序号<\/td>";
          strVar += "            <td rowspan=\"2\">检查表中检查问题<\/td>";
          strVar += "            <td rowspan=\"2\">问题描述<\/td>";
          strVar += "            <td rowspan=\"2\">问题照片<\/td>";
          strVar += "            <td rowspan=\"2\">整改意见<\/td>";
          strVar += "            <td colspan=\"2\">问题归属<\/td>";
          strVar += "        <\/tr>";
          strVar += "        <tr style=\"font-size:11\">";
          strVar += "            <td>文件、资料类<\/td>";
          strVar += "            <td>现场类<\/td>";
          strVar += "        <\/tr>";
          var counter = 0;
          temp.danger[key].forEach(element => {
            counter += 1;
          });
          var index = 1;


          temp.danger[key].forEach(element => {
            strVar += "        <tr style=\"font-size:11\">";
            if (index == 1) {
              strVar += "            <td rowspan =" + counter + " >" + key + "<\/td>";
            }
            strVar += "            <td>" + index + "<\/td>";
            strVar += "            <td>" + element.checkup_item_inspection_content + "<\/td>";
            strVar += "            <td>" + element.checkup_evaluation_problem_description + "<\/td>";
            if (element.evaluation_image.length == 0) {
              strVar += "            <td><\/td>";
            } else {
              strVar += " <td>";
              for (let indey = 0; indey < element.evaluation_image.length; indey++) {
                strVar += "            <img src=\"" + element.evaluation_image[indey].source + "\" alt=\"\" height=30 width=30 \/>";
              }
              strVar += "<\/td>";
            }
            strVar += "            <td>" + element.checkup_evaluation_improve_suggest + "<\/td>";
            if (element.evaluation_method_type_id == "1") {
              strVar += "            <td>&radic;<\/td>";
              strVar += "            <td><\/td>";
            } else if (element.evaluation_method_type_id == "2" || element.evaluation_method_type_id == "3") {
              strVar += "            <td><\/td>";
              strVar += "            <td>&radic;<\/td>";
            } else {
              strVar += "            <td><\/td>";
              strVar += "            <td><\/td>";
            }
            strVar += "        <\/tr>";
            index++;
          });
          strVar += "<\/table>";
          strVar += "<\/div>";
        }
      }
      strVar += "<span lang=EN-US style='font-size:10.5pt;font-family:等线'><br clear=all style='page-break-before:always'><\/span>";
      this.outputWord(strVar);
    },

    outputWord(strVar) {
      let cssHTML = ``
      let converted = `<!DOCTYPE html><html>
            <head>
                <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
                <style type="text/css">table{border-collapse: collapse;table-layout: fixed;justify-content: center}</style>
                <style>table td,th{ justify-content: "center";font-size: 8px;word-break: keep-all;white-space: nowrap;text-align: center;}</style>
            </head>
            <body>
                ${strVar}
            </body>
            </html>`;
      this.content = htmlDocx.asBlob(converted,);
    },
    saveAsWord() {
      // const blob = new Blob([this.content], { type: "application/msword;charset=utf-8" });
      let binaryData = [];
      console.log('123')
      binaryData.push(this.content);
      let url = window.URL.createObjectURL(new Blob(binaryData, { type: "application/msword;charset=utf-8" }));
      let downloadElement = document.createElement("a");
      downloadElement.href = url;
      downloadElement.download = "输出报告";
      document.body.appendChild(downloadElement);
      downloadElement.click();
      document.body.removeChild(downloadElement);
      window.URL.revokeObjectURL(url);
    },
    openModifyProject() {
      this.showAddDialog = true
      this.loadProjectInfoData()
    },
    deleteProject() {
      this.$confirm('是否删除项目?').then(() => {
        deleteCheckupProjectInfo({
          checkup_project_id: this.checkup_project_id
        }).then(res => {
          if (res.data.status == "1") {
            this.$router.back()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    cancelProjectMemberDialog() {
      this.showProjectMemberDialog = false
    },
    okProjectMemberDialog() {
      this.showProjectMemberDialog = false
    },
    cancelModifyProjectDialog() {
      this.showModifyProjectDialog = false
    },
    cancelProjectDocumentDialog() {
      this.showProjectDocumentDialog = false
    },
    cancelDocumentUploadDialog() {
      this.showDocumentUploadDialog = false
    },
    cancelNewCategoryDialog() {
      this.showNewCategoryDialog = false
    },

    loadProjectMemberData() {
      getCheckupProjectUserList({
        "checkup_project_id": this.checkup_project_id
      }).then(res => {
        this.projectMemberData = res.data.data.checkup_project_user_list
        this.showProjectMemberDialog = true
      })
    },
    openProjectMember() {
      this.loadProjectMemberData()
    },
    deleteProjectMember(row) {
      deleteCheckupProjectUserInfo({
        "checkup_project_id": this.checkup_project_id,
        "organization_user_id": row.organization_user_id
      }).then(res => {
        this.loadProjectMemberData()
      })
    },
    addProjectMember() {
      this.showNewProjectMemberDialog = true
      this.loadPersonData()
    },

    viewProjectDocument() {

    },
    modifyProjectDocument(row) {
      console.log(row)
      this.modifyFileInfo = { ...row }
      this.checkup_project_file_category_id = row.checkup_project_file_category_info.checkup_project_file_category_id
      this.showModifyFileInfoDialog = true
      this.loadFileCategoryList()
    },
    deleteProjectDocument(row) {
      this.$confirm('是否删除数据?').then(() => {
        deleteCheckupProjectFileInfo({
          "checkup_project_id": this.checkup_project_id,
          "checkup_project_file_id_list": [row.checkup_project_file_id]
        }).then(res => {
          this.loadProjectDocumentData()
        })
      })
    },
    openManageCategoryDialog() {
      this.showCategoryDialog = true
      this.loadFileCategoryList()
    },
    loadFileCategoryList() {
      getCheckupProjectFileCategoryList().then(res => {
        this.checkup_project_file_category_list = res.data.data.checkup_project_file_category_list
        this.createCheckupProjectFileCategoryTree()
      })
    },
    createCheckupProjectFileCategoryTree() {
      let parents = []
      this.checkup_project_file_category_list.forEach(x => {
        if (x.checkup_project_file_category_parent_name == "") {
          parents.push(x)
        }
      })
      parents.forEach(x => {
        this.findChildrenCategory(x)
      })
      this.checkup_project_file_category_list_tree = parents
    },
    findChildrenCategory(parent) {
      let children = []
      this.checkup_project_file_category_list.forEach(x => {
        if (x.checkup_project_file_category_parent_name == parent.checkup_project_file_category_name) {
          children.push(x)
        }
      })
      children.forEach(x => {
        this.findChildrenCategory(x)
      })
      if (children.length > 0) {
        parent.children = children
      }
    },
    cancelCategoryDialog() {
      this.showCategoryDialog = false
    },
    addNewCategory() {
      this.showNewCategoryDialog = true
    },
    openDocuemntUploadDialog() {
      this.showDocumentUploadDialog = true
      this.loadFileCategoryList()
    },
    addNewFileCategory() {
      if (this.newFileCategoryForm.checkup_project_file_category_name.trim().length == 0) {
        this.$message.error("请输入分类名称")
        return
      }
      let parentid = ""
      if (this.newFileCategoryForm.checkup_project_file_category_parent_id.length > 0) {
        parentid = this.newFileCategoryForm.checkup_project_file_category_parent_id[this.newFileCategoryForm.checkup_project_file_category_parent_id.length - 1]
      }
      saveCheckupProjectFileCategoryInfo({
        "checkup_project_file_category_id": this.newFileCategoryForm.checkup_project_file_category_id,
        "checkup_project_file_category_parent_id": parentid,
        "checkup_project_file_category_name": this.newFileCategoryForm.checkup_project_file_category_name,
      }).then(res => {
        if (res.data.status == "1") {
          this.showNewCategoryDialog = false
          this.loadFileCategoryList()
          this.newFileCategoryForm = {
            checkup_project_file_category_id: '',
            checkup_project_file_category_parent_id: '',
            checkup_project_file_category_name: ''
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    deleteFileCateogry(data) {
      this.$confirm('是否删除数据?').then(() => {
        deleteCheckupProjectFileCategoryInfo({
          checkup_project_file_category_id_list: [data.checkup_project_file_category_id]
        }).then(res => {
          if (res.data.status == "1") {
            this.loadFileCategoryList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    modifyFileCateogry(data) {
      console.log(data)
      this.newFileCategoryForm = {
        checkup_project_file_category_id: data.checkup_project_file_category_id,
        checkup_project_file_category_parent_id: this.findParentListByName(data.checkup_project_file_category_name),
        checkup_project_file_category_name: data.checkup_project_file_category_name
      }
      this.showNewCategoryDialog = true
    },
    findParentListByName(name) {
      let parents = []
      let node = this.checkup_project_file_category_list.find(x => x.checkup_project_file_category_name == name)
      this.findParentList(node, parents)
      return parents
    },
    findParentList(node, parents) {
      let parent = this.checkup_project_file_category_list.find(x => x.checkup_project_file_category_name == node.checkup_project_file_category_parent_name)
      if (parent) {
        parents.unshift(parent.checkup_project_file_category_id)
        this.findParentList(parent, parents)
      }
    },
    cancelNewFileCategory() {
      this.showNewCategoryDialog = false
      this.newFileCategoryForm = {
        checkup_project_file_category_id: '',
        checkup_project_file_category_parent_id: '',
        checkup_project_file_category_name: ''
      }
    },
    deleteFileCategory() {
      this.$confirm('是否删除数据?').then(() => {
        let data = this.$refs.fileCategoryTreeRef.getCheckedNodes()
        if (data.length == 0) {
          this.$message.error("请选择待删除数据")
          return
        }
        let temp = []
        data.forEach(x => {
          temp.unshift(x.checkup_project_file_category_id)
        })
        deleteCheckupProjectFileCategoryInfo({
          checkup_project_file_category_id_list: temp
        }).then(res => {
          if (res.data.status == "1") {
            this.loadFileCategoryList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    cancelCategoryManager() {
      this.showCategoryDialog = false
    },
    okCategoryManager() {
      this.showCategoryDialog = false
    },
    okUploadProjectDocument() {
      let checkup_project_file_category_id = ""
      let that = this
      if (this.uploadFileForm.checkup_project_file_category_id.length > 0) {
        checkup_project_file_category_id = that.uploadFileForm.checkup_project_file_category_id[that.uploadFileForm.checkup_project_file_category_id.length - 1]
      }
      saveCheckupProjectFileInfo({
        ...this.uploadFileForm,
        checkup_project_file_category_id: checkup_project_file_category_id,
        checkup_project_id: this.checkup_project_id,
        checkup_project_file_url: this.uploadFileUrl
      }).then(res => {
        this.loadProjectDocumentData()
        this.cancelUploadProjectDocument()
      })
    },
    cancelUploadProjectDocument() {
      this.showDocumentUploadDialog = false
      this.uploadFileUrl = ""
      this.uploadFileForm = {
        "checkup_project_file_id": "0",
        "checkup_project_id": "",
        "checkup_project_file_category_id": "",
        "checkup_project_file_url": ""
      }
    },
    checkHandleEdit(row) {
      this.$router.push('/projectManag/ChecklistEdit/' + this.checkup_project_id + "-" + row.checkup_subject_id + "-" + row.checkup_subject_weight_coefficient)
    }
  },
  beforeDestroy() {
    eventBus.$off("toProjectDetail");
  },
};
</script>
<style scoped>
h3 {
  float: left;
  margin-left: 20px;
  font-size: 16px;
  color: #101010;
}

#timeLineDiv {
  width: 300px;
  height: calc(100% - 20px);
  background: #F2F6FA;
  display: inline-block;
  margin: 10px 0 10px 10px;
}


#CheckTable {
  width: calc(100% - 320px);
  background: #fff;
  height: calc(100% - 20px);
  float: right;
  margin: 10px 10px 10px 0px;
}

#ProjectDetail>>>.el-timeline-item__tail {
  border-left: 3px solid #bec0c3 !important;
}

.el-timeline {
  padding: 40px;
}

#ProjectDetail>>>.el-timeline-item__timestamp {
  text-align: left;
}

#ProjectDetail>>>.el-timeline-item__content {
  text-align: left;
  font-size: 16px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/views/Orgin/ProjectManag/Detail/ProjectDetail.vue